import { FetchError } from "common/fetch/types";
import { useBuildNext, useLocation } from "common/router/hooks";
import { Optional } from "common/utils/types";

import ErrorPage from "client/common/components/errors/ErrorPage";
import FetchErrorPage from "client/common/components/errors/FetchErrorPage";
import { urls } from "client/routes";

import { IncentiveAccessErrorData, IncentiveAccessErrorKind } from "../types";

type IncentiveErrorPageProps = {
  error: Optional<FetchError<{}, IncentiveAccessErrorData>>;
};

/**
 * Shown when an incentive fails to load. A segment-targeted incentive the visitor can't see
 * explains why, asking logged-out visitors to sign in.
 */
const IncentiveErrorPage = ({ error }: IncentiveErrorPageProps) => {
  const location = useLocation();
  const buildNext = useBuildNext();

  switch (error?.data?.kind) {
    case IncentiveAccessErrorKind.SignInRequired:
      return (
        <ErrorPage
          title={error.detail}
          description={null}
          buttonText="Sign in"
          buttonLink={buildNext(urls.accounts.login({ search: { next: location.current.href } }))}
          refresh={true}
        />
      );
    case IncentiveAccessErrorKind.NotEligible:
      return <ErrorPage title={error.detail} description={null} />;
    default:
      return <FetchErrorPage error={error} entityName="incentive" />;
  }
};

export default IncentiveErrorPage;
